export default __webpack_public_path__ + "static/media/alert-welcome.50d91344.png";